import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export function AuthErrorPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [debugInfo, setDebugInfo] = useState('')

  useEffect(() => {
    const error = searchParams.get('error')
    const allParams = Object.fromEntries(searchParams.entries())

    setDebugInfo(`Error: ${error}, All params: ${JSON.stringify(allParams)}`)
    console.log('[Auth Error Page]', { error, allParams })

    if (error && error.includes('AccountDeactivated')) {
      let email = ''

      if (error.startsWith('/login?error=AccountDeactivated')) {
        navigate(error, { replace: true })
        return
      }

      if (error.includes(':')) {
        email = error.split(':')[1] || ''
      }

      const targetUrl = email
        ? `/login?error=AccountDeactivated&email=${encodeURIComponent(email)}`
        : '/login?show_reactivation=true'

      console.log('[Auth Error Redirect]', targetUrl)
      navigate(targetUrl, { replace: true })
    } else {
      navigate('/login', { replace: true })
    }
  }, [navigate, searchParams])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <p className="text-muted-foreground">Redirecting...</p>
        {import.meta.env.DEV && (
          <pre className="mt-4 text-xs text-muted-foreground/60">{debugInfo}</pre>
        )}
      </div>
    </div>
  )
}

export default AuthErrorPage
